import {
  Status,
  type GenericSearchItem,
  type Maybe,
  type SearchResultAbout,
  type State,
} from '@onxmaps/supergraph'
import type { SearchResultItem } from '@onxmaps/search-web'

/**
 * SearchResult class used to initialize a search result object for use in the search-service
 */
class SearchResult implements SearchResultItem {
  item: GenericSearchItem
  nearby: Maybe<string | undefined>
  countyName: Maybe<string | undefined>
  state: State
  about: SearchResultAbout

  constructor(args: SearchResultItem) {
    this.countyName = args.countyName
    this.nearby = args.nearby
    this.item = args.item

    this.item.id = args.item?.id ?? ''

    // Identifiers
    this.item.identifiers = args.item.identifiers ?? []

    // Photos
    this.item.photos = args.item.photos ?? []

    // Point
    this.item.point = {
      type: args.item.point?.type ?? 'Point',
      coordinates: args.item.point?.coordinates ?? [0, 0],
    }

    // Presentation
    this.item.presentation = args.item?.presentation
      ? args.item?.presentation
      : []
    this.item.richPlaceID = args.item?.richPlaceID ?? null
    // Search Scopes/Category
    this.item.searchScopes = args.item?.searchScopes ?? []

    // State
    this.state = {
      abbreviation:
        args.state !== null && args.state?.abbreviation !== undefined
          ? args.state.abbreviation
          : '',
      name:
        args.state !== null && args.state?.name !== undefined
          ? args.state.name
          : '',
      id: args.state?.id ?? '',
      status: args.state?.status ?? Status.Pending,
      nationalParks: args.state?.nationalParks ?? [],
    }
    this.about = {
      ...args.about,
      id: args.about?.id ?? '',
      status: args.about?.status ?? Status.Pending,
    } as SearchResultAbout
  }
}

/**
 * Initializes a search result to a default shape
 */
export const getSearchResultDefault = (
  response: SearchResultItem
): SearchResultItem => {
  return new SearchResult(response)
}
